/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DetailReleveCompteurDto } from '../models/detail-releve-compteur-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des détails de relevés de compteurs
 */
@Injectable({
  providedIn: 'root',
})
export class DetailsRelevesCompteursService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation detailReleveCompteurGetList
   */
  static readonly DetailReleveCompteurGetListPath = '/api/details-releves-compteurs/list/{releveCompteurId}';

  /**
   * Renvoie la liste des détails du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailReleveCompteurGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailReleveCompteurGetList$Response(params: {

    /**
     * Identifiant du relevé de compteur
     */
    releveCompteurId: number;
  }): Observable<StrictHttpResponse<Array<DetailReleveCompteurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DetailsRelevesCompteursService.DetailReleveCompteurGetListPath, 'get');
    if (params) {
      rb.path('releveCompteurId', params.releveCompteurId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DetailReleveCompteurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des détails du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailReleveCompteurGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailReleveCompteurGetList(params: {

    /**
     * Identifiant du relevé de compteur
     */
    releveCompteurId: number;
  }): Observable<Array<DetailReleveCompteurDto>> {

    return this.detailReleveCompteurGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DetailReleveCompteurDto>>) => r.body as Array<DetailReleveCompteurDto>)
    );
  }

  /**
   * Path part for operation detailReleveCompteurLoadList
   */
  static readonly DetailReleveCompteurLoadListPath = '/api/details-releves-compteurs/load-list/{releveCompteurId}';

  /**
   * Renvoie la liste des détails du relevé de compteur spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailReleveCompteurLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurLoadList$Response(params: {

    /**
     * Identifiant du relevé de compteur
     */
    releveCompteurId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DetailsRelevesCompteursService.DetailReleveCompteurLoadListPath, 'post');
    if (params) {
      rb.path('releveCompteurId', params.releveCompteurId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des détails du relevé de compteur spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailReleveCompteurLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurLoadList(params: {

    /**
     * Identifiant du relevé de compteur
     */
    releveCompteurId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.detailReleveCompteurLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation detailReleveCompteurGet
   */
  static readonly DetailReleveCompteurGetPath = '/api/details-releves-compteurs/{id}';

  /**
   * Renvoie le détail du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailReleveCompteurGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailReleveCompteurGet$Response(params: {

    /**
     * Identifiant du détail de relevé de compteur
     */
    id: number;
  }): Observable<StrictHttpResponse<DetailReleveCompteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetailsRelevesCompteursService.DetailReleveCompteurGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetailReleveCompteurDto>;
      })
    );
  }

  /**
   * Renvoie le détail du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailReleveCompteurGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailReleveCompteurGet(params: {

    /**
     * Identifiant du détail de relevé de compteur
     */
    id: number;
  }): Observable<DetailReleveCompteurDto> {

    return this.detailReleveCompteurGet$Response(params).pipe(
      map((r: StrictHttpResponse<DetailReleveCompteurDto>) => r.body as DetailReleveCompteurDto)
    );
  }

  /**
   * Path part for operation detailReleveCompteurPut
   */
  static readonly DetailReleveCompteurPutPath = '/api/details-releves-compteurs/{id}';

  /**
   * Met à jour le détail du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailReleveCompteurPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurPut$Response(params: {

    /**
     * Identifiant du détail de relevé de compteur à mettre à jour
     */
    id: number;

    /**
     * Détail du relevé de compteur
     */
    body: DetailReleveCompteurDto
  }): Observable<StrictHttpResponse<DetailReleveCompteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetailsRelevesCompteursService.DetailReleveCompteurPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetailReleveCompteurDto>;
      })
    );
  }

  /**
   * Met à jour le détail du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailReleveCompteurPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurPut(params: {

    /**
     * Identifiant du détail de relevé de compteur à mettre à jour
     */
    id: number;

    /**
     * Détail du relevé de compteur
     */
    body: DetailReleveCompteurDto
  }): Observable<DetailReleveCompteurDto> {

    return this.detailReleveCompteurPut$Response(params).pipe(
      map((r: StrictHttpResponse<DetailReleveCompteurDto>) => r.body as DetailReleveCompteurDto)
    );
  }

  /**
   * Path part for operation detailReleveCompteurDelete
   */
  static readonly DetailReleveCompteurDeletePath = '/api/details-releves-compteurs/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailReleveCompteurDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailReleveCompteurDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DetailsRelevesCompteursService.DetailReleveCompteurDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailReleveCompteurDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailReleveCompteurDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.detailReleveCompteurDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation detailReleveCompteurPost
   */
  static readonly DetailReleveCompteurPostPath = '/api/details-releves-compteurs/{releveCompteurId}';

  /**
   * Crée le détail du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailReleveCompteurPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurPost$Response(params: {

    /**
     * Identifiant du relevé du compteur sur lequel ajouter le détail
     */
    releveCompteurId: number;

    /**
     * Détail du relevé de compteur
     */
    body: DetailReleveCompteurDto
  }): Observable<StrictHttpResponse<DetailReleveCompteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetailsRelevesCompteursService.DetailReleveCompteurPostPath, 'post');
    if (params) {
      rb.path('releveCompteurId', params.releveCompteurId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetailReleveCompteurDto>;
      })
    );
  }

  /**
   * Crée le détail du relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailReleveCompteurPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurPost(params: {

    /**
     * Identifiant du relevé du compteur sur lequel ajouter le détail
     */
    releveCompteurId: number;

    /**
     * Détail du relevé de compteur
     */
    body: DetailReleveCompteurDto
  }): Observable<DetailReleveCompteurDto> {

    return this.detailReleveCompteurPost$Response(params).pipe(
      map((r: StrictHttpResponse<DetailReleveCompteurDto>) => r.body as DetailReleveCompteurDto)
    );
  }

  /**
   * Path part for operation detailReleveCompteurPost2
   */
  static readonly DetailReleveCompteurPost2Path = '/api/details-releves-compteurs';

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailReleveCompteurPost2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurPost2$Response(params: {

    /**
     * Entité
     */
    body: DetailReleveCompteurDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DetailsRelevesCompteursService.DetailReleveCompteurPost2Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailReleveCompteurPost2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailReleveCompteurPost2(params: {

    /**
     * Entité
     */
    body: DetailReleveCompteurDto
  }): Observable<void> {

    return this.detailReleveCompteurPost2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
